import { ServiceResponse, ServiceResponseNoContent } from "../../models/serviceResponse";

const IApiClientId = "@se/platform:IApiClient";

interface IApiClient {

    Get<TOutput>(baseUrl: string, resourceUrl: string, accessToken: string): Promise<ServiceResponse<TOutput>>;

    Put<TInput, TOutput>(baseUrl: string, resourceUrl: string, content: TInput, accessToken: string): Promise<ServiceResponse<TOutput>>;

    PutNoResponse<TInput>(baseUrl: string, resourceUrl: string, content: TInput, accessToken: string): Promise<ServiceResponseNoContent>;

    Post<TInput, TOutput>(baseUrl: string, resourceUrl: string, content: TInput, accessToken: string): Promise<ServiceResponse<TOutput>>;

    PostNoResponse<TInput>(baseUrl: string, resourceUrl: string, content: TInput, accessToken: string): Promise<ServiceResponseNoContent>;

    Patch<TInput, TOutput>(baseUrl: string, resourceUrl: string, content: TInput, accessToken: string): Promise<ServiceResponse<TOutput>>;

    Delete(baseUrl: string, resourceUrl: string, accessToken: string): Promise<ServiceResponseNoContent>;
};

export { IApiClientId, IApiClient };